/* eslint-disable no-underscore-dangle */
import React, { Component, Fragment } from 'react';
import Moment from 'react-moment';
import {
  FaCheckCircle, FaTruck, FaTruckLoading, FaTimesCircle, FaAngleDown, FaAngleUp, FaQuestionCircle,
} from 'react-icons/fa';
import { PulseLoader } from 'react-spinners';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { handleOrderStatus } from '../../../queries';

import ProductLG from './Product/index.lg';
import ProductSM from './Product/index.sm';

import {
  ListItem, Button, Details, Table,
} from './styles';
import spacer from '../../../assets/images/spacer.png';

class Item extends Component {
  state = {
    popover: false,
    loading: false,
  }

  componentDidMount = () => {
    const { date, delivery } = this.props.item;

    this.minHour = new Date(date);
    this.maxHour = new Date(date);
    this.minHour.setMinutes(this.minHour.getMinutes() + delivery.smaller);
    this.maxHour.setMinutes(this.maxHour.getMinutes() + delivery.bigger);
  }

  handleOrderStatus = (status) => {
    this.setState({ loading: true });

    this.props
      .handleOrderStatus({
        variables: {
          storeId: this.props.store.id,
          orderId: this.props.item._id,
          storeOrderId: this.props.item.storeOrderId,
          userId: this.props.item.clientInfo.id,
          storeName: this.props.store.name,
          status,
        },
      })
      .then(async () => {
        this.setState({ loading: false });
        // this.props.refetchQueries();
        this.props.alert.success('Pedido atualizado com sucesso');
      });
  }

  cancelOrder = () => {
    const {
      wirecardId, _id, storeOrderId, clientInfo,
    } = this.props.item;

    this.props.openCancelOrderModal(wirecardId, _id, storeOrderId, clientInfo.id);
  }

  showPopover = () => {
    this.setState({ popover: true }, () => {
      document.addEventListener('click', this.hidePopover);
    });
  }

  hidePopover = (e) => {
    if (!e.srcElement.offsetParent || e.srcElement.offsetParent.id !== 'popover') {
      this.setState({ popover: false }, () => {
        document.removeEventListener('click', this.hidePopover);
      });
    }
  }

  onPress = () => {
    this.props.onPressItem(this.props.id);
  };

  render() {
    const { loading } = this.state;
    const {
      date,
      storeOrderId,
      clientInfo,
      products,
      shipping,
      billing,
      installment,
      subtotal,
      storeAmount,
      tax,
      status,
    } = this.props.item;

    return (
      <div>
        <ListItem selected={this.props.selected}>
          <div className="row" style={{ minWidth: '125px' }}>
            <h2>{`Pedido nº ${storeOrderId}`}</h2>
            <Moment className="date" format="DD/MM/YY [ás] HH:mm">{date}</Moment>
          </div>
          <div className="row" style={{ minWidth: '125px' }}>
            <h2>Cliente</h2>
            <p>{clientInfo.name}</p>
          </div>
          <div className="row" style={{ minWidth: '115px' }}>
            <h2>Valor</h2>
            <p>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(subtotal)}</p>
          </div>
          <div className="row last-row" style={{ minWidth: '125px' }}>
            {status.current === 'waiting' && (<h2 className="status-waiting">Pendente</h2>)}
            {status.current === 'confirmed' && (<h2 className="status">Confirmado</h2>)}
            {status.current === 'shipment' && (<h2 className="status">Saiu para entrega</h2>)}
            {status.current === 'complete' && (<h2 className="status">Entregue</h2>)}
            {status.current === 'cancelled' && (<h2 className="status cancelled">Cancelado</h2>)}
            <div className="progress-bar">
              <div className="dot-container"><span className={status.current !== 'waiting' && status.current !== 'cancelled' ? 'dot active' : 'dot'} /></div>
              <div className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'cancelled' ? 'bar active' : 'bar'} />
              <div className="dot-container"><span className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'cancelled' ? 'dot active' : 'dot'} /></div>
              <div className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'shipment' && status.current !== 'cancelled' ? 'bar active' : 'bar'} />
              <div className="dot-container"><span className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'shipment' && status.current !== 'cancelled' ? 'dot active' : 'dot'} /></div>
            </div>
          </div>
          <div className="button-container">
            <div className="space" style={{ flex: 1 }} />
            {status.current === 'waiting' && (
              <Button type="submit" style={{ minWidth: '144px' }} onClick={() => this.handleOrderStatus('confirmed')}>
                {!loading ? (
                  <>
                    <FaCheckCircle className="fa fa-check-circle" />
                    <span>Confirmar</span>
                  </>
                ) : (
                  <PulseLoader
                    sizeUnit="px"
                    size={7}
                    color="#2FAA33"
                    loading={loading}
                  />
                )}
              </Button>
            )}
            {status.current === 'confirmed' && (
              <Button type="submit" title="Saiu para entrega" style={{ minWidth: '144px' }} onClick={() => this.handleOrderStatus('shipment')}>
                {!loading ? (
                  <>
                    <FaTruck className="fa fa-truck" />
                    <span>Saiu para entrega</span>
                  </>
                ) : (
                  <PulseLoader
                    sizeUnit="px"
                    size={7}
                    color="#2FAA33"
                    loading={loading}
                  />
                )}
              </Button>
            )}
            {status.current === 'shipment' && (
              <Button type="submit" style={{ minWidth: '144px' }} onClick={() => this.handleOrderStatus('complete')}>
                {!loading ? (
                  <>
                    <FaTruckLoading className="fa fa-truck-loading" />
                    <span>Entregue</span>
                  </>
                ) : (
                  <PulseLoader
                    sizeUnit="px"
                    size={7}
                    color="#2FAA33"
                    loading={loading}
                  />
                )}
              </Button>
            )}
            {status.current !== 'complete' && status.current !== 'cancelled' && (
            <Button type="submit" onClick={this.cancelOrder} cancel>
              <FaTimesCircle className="fa fa-times-circle" />
              <span>Cancelar</span>
            </Button>
            )}
            <Button type="submit" onClick={this.onPress}>
              <span>Detalhes</span>
              {!this.props.selected && <FaAngleDown className="fa fa-angle-down" />}
              {this.props.selected && <FaAngleUp className="fa fa-angle-up" />}
            </Button>
          </div>
        </ListItem>
        <Details selected={this.props.selected} cancelled={status.current === 'cancelled'}>
          <img src={spacer} alt="" className="spacer" />
          <div className="container">
            <h2>Detalhes do pedido</h2>
            {status.current !== 'cancelled' && (
              <div className="progress-bar">
                <div className="dot-container">
                  <div className="status-container first-child-status">
                    <p className={status.current !== 'cancelled' && status.current !== 'waiting' ? 'status active-status' : 'status'}>Confirmado</p>
                    {status.confirmed ? <Moment className="date" format="DD/MM/YY [ás] HH:mm">{status.confirmed.date}</Moment> : <p>Aguardando</p>}
                  </div>
                  <span className={status.current !== 'cancelled' && status.current !== 'waiting' ? 'dot active' : 'dot'} />
                </div>
                <div className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'cancelled' ? 'bar active' : 'bar'} />
                <div className="dot-container">
                  <div className="status-container">
                    <p className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'cancelled' ? 'status active-status' : 'status'}>Saiu para entrega</p>
                    {status.shipment ? <Moment className="date" format="DD/MM/YY [ás] HH:mm">{status.shipment.date}</Moment> : <p>Aguardando</p>}
                  </div>
                  <span className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'cancelled' ? 'dot active' : 'dot'} />
                </div>
                <div className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'shipment' && status.current !== 'cancelled' ? 'bar active' : 'bar'} />
                <div className="dot-container">
                  <div className="status-container">
                    <p className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'shipment' && status.current !== 'cancelled' ? 'status active-status' : 'status'}>Entregue</p>
                    {status.complete ? <Moment className="date" format="DD/MM/YY [ás] HH:mm">{status.complete.date}</Moment> : <p>Aguardando</p>}
                  </div>
                  <span className={status.current !== 'waiting' && status.current !== 'confirmed' && status.current !== 'shipment' && status.current !== 'cancelled' ? 'dot active' : 'dot'} />
                </div>
              </div>
            )}
            {status.current === 'cancelled' && (
              <div className="row-2 cancelled">
                <div className="info">
                  <span>Pedido cancelado</span>
                  <p>{`Motivo: ${status.cancelled.reason}`}</p>
                </div>
              </div>
            )}
            <div className="row-2">
              <div className="info">
                <span>Modo de entrega</span>
                <p>{shipping.type === 'delivery' ? 'Delivery' : 'Agendamento'}</p>
              </div>
              <div className="info">
                {shipping.type === 'delivery' ? <span className="shipping-date">Previsão de entrega</span> : <span className="shipping-date">Data de entrega</span>}
                {shipping.type === 'delivery' && (
                  <p>
                    {'Das '}
                    <Moment className="date" format="HH:mm">{this.minHour}</Moment>
                    {' até '}
                    <Moment className="date" format="HH:mm">{this.maxHour}</Moment>
                  </p>
                )}
                {shipping.type === 'booking' && <p>{shipping.date}</p>}
              </div>
              <div className="info">
                <span>Forma de pagamento</span>
                <p>{`Pagamento online aprovado (Crédito ${billing.brand} em ${installment}x)`}</p>
              </div>
            </div>
            <div className="row-2 last-row">
              <div className="info address">
                <span>Dados do cliente</span>
                <p>
                  <span>Nome:</span>
                  {clientInfo.name}
                </p>
                <p>
                  <span>Telefone:</span>
                  {clientInfo.phoneNumber}
                </p>
                <p>
                  <span>E-mail:</span>
                  {clientInfo.email}
                </p>
                {clientInfo.cpf && clientInfo.cpf.length !== 0 && clientInfo.cpf.length === 11 && (
                <p>
                  <span>CPF:</span>
                  {clientInfo.cpf}
                </p>
                )}
                {clientInfo.cpf && clientInfo.cpf.length !== 0 && clientInfo.cpf.length > 11 && (
                <p>
                  <span>CNPJ:</span>
                  {clientInfo.cpf}
                </p>
                )}
              </div>
              <div className="info address">
                <span>Endereço de entrega</span>
                <p>
                  <span>Rua:</span>
                  {shipping.address.logradouro}
                </p>
                <p>
                  <span>Número:</span>
                  {shipping.address.numero}
                </p>
                {shipping.address.complemento.length !== 0 && (
                <p>
                  <span>Complemento:</span>
                  {shipping.address.complemento}
                </p>
                )}
                <p>
                  <span>Bairro:</span>
                  {shipping.address.bairro}
                </p>
                <p>
                  <span>Cidade:</span>
                  {shipping.address.cidade}
                </p>
                <p>
                  <span>Estado:</span>
                  {shipping.address.uf}
                </p>
                <p>
                  <span>CEP:</span>
                  {shipping.address.cep}
                </p>
              </div>
              <div className="info" />
            </div>
            <Table>
              <table className="lg">
                <thead>
                  <tr className="thead">
                    <th>Nome</th>
                    <th>Código</th>
                    <th>Preço original</th>
                    <th>Qtd.</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map(product => (
                    <ProductLG
                      key={product.id}
                      item={product}
                    />
                  ))}
                </tbody>
              </table>
              <table className="sm">
                {products.map(product => (
                  <ProductSM
                    key={product.id}
                    item={product}
                  />
                ))}
              </table>
            </Table>
            <div className="order-totals">
              <table className="order-table" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>Subtotal</td>
                    <td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(subtotal - shipping.tax)}</td>
                  </tr>
                  <tr>
                    <td>Taxa de entrega</td>
                    <td>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(shipping.tax)}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td className="label">Total</td>
                    <td className="price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(subtotal)}</td>
                  </tr>
                  {status.current === 'cancelled' && (
                    <tr>
                      <td className="label">Total estornado</td>
                      <td className="price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(subtotal)}</td>
                    </tr>
                  )}
                  {status.current !== 'cancelled' && (
                    <Fragment>
                      <tr>
                        <td className="label">
                          {'Taxa operacional'}
                          <FaQuestionCircle className="fa fa-question-circle" onClick={this.showPopover} />
                          {this.state.popover && (
                          <div id="popover" className="popover">
                            <div className="text">
                              {'A taxa operacional tem como objetivo cobrir os custos e despesas da plataforma, para continuarmos oferencedo excelentes serviços para sua loja e seus clientes.'}
                            </div>
                          </div>
                          )}
                        </td>
                        <td className="price">{`- ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(tax)}`}</td>
                      </tr>
                      <tr>
                        <td className="label">A loja recebe</td>
                        <td className="price">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(storeAmount)}</td>
                      </tr>
                    </Fragment>
                  )}
                </tfoot>
              </table>
            </div>
          </div>
        </Details>
      </div>
    );
  }
}

export default compose(
  withAlert(),
  graphql(handleOrderStatus, { name: 'handleOrderStatus' }),
)(Item);
